import React, { FunctionComponent } from 'react';
import { Box, Button } from '@mui/material';
import { SxProps } from '@mui/material/styles';
interface InProps {
  className: string;
  size?: 'large' | 'small';
  onClick: VoidFunction;
  buttonText: string;
  gridArea?: string;
  backgroundColor?: string;
  color?: string;
  disabled?: boolean;
  sx: SxProps;
}

export const GoogleButton: FunctionComponent<InProps> = (props) => {
  const { size, onClick, buttonText, disabled, sx } = props;

  return (
    <Button disabled={disabled} fullWidth size={size} sx={sx} onClick={onClick}>
      {buttonText}
      <Box component={'img'} src={`./img/google-button.png`} />
    </Button>
  );
};
